import { useEffect, useState } from "react"
import { DeepMap, FieldErrors, UseFormClearErrors, UseFormRegister, UseFormSetError, UseFormSetValue, UseFormWatch } from "react-hook-form"
import { FormValues } from "."
import useLazyQuery from "../../../customHooks/useLazyQuery"
import { useAppSelector } from "../../../store/hooks"

interface Response {
    data: {
        City: string
        State: string
    }
    userMessage: string
}

interface Props {
    register: UseFormRegister<FormValues>
    setValue:UseFormSetValue<FormValues>
    watch:UseFormWatch<FormValues>
    clearErrors: UseFormClearErrors<FormValues>
    setError: UseFormSetError<FormValues>
    errors: DeepMap<FormValues, FieldErrors>
    getData:(url: string) => Promise<void>
    isLoading: boolean
    data: Response | null
    error: any
}
const Zipcode = ({
  register,
  setValue,
  watch,
  errors, 
  setError,
  clearErrors,
  getData,
  isLoading,
  data,
  error
}:Props)=>{
  const zip_code = watch("employee_zip_code")
  const { onChange: onChangeZipcode, ...restZipcode } = register('employee_zip_code',{
    validate: (value) => {
      if(!error){
        return true
      }
      return 'Zipcode is not valid'
    },
    minLength: {
      value: 5,
      message: 'Zip code must be 5 characters'
    },
    required: 'Zipcode is required'
  })

  const handleChangeZipcode = (e: React.FormEvent<HTMLInputElement>) => {
    let valueZipcode = e.currentTarget.value
    if (valueZipcode.length <= 5){
      onChangeZipcode(e)
      if(valueZipcode.length === 5){
        const promise = getData(`https://confiejarvis.com/thor/get/${valueZipcode}.json`)
      }
    }
  }
   return(
    <div className="c-input">
      <div className="c-input__header">
        <span className="c-input__title">Zip Code</span>
        {
          isLoading && <span className="c-input__wait">Searching...</span>
        }
      </div>
      <input type="text" className={`c-input__input ${errors.employee_zip_code && 'c-input__input--error'}`}
        value={zip_code}
        onChange={handleChangeZipcode}
        {...restZipcode}
      />
      <span className="c-input__error">{errors?.employee_zip_code?.message}</span>
    </div>
    )
}
export default Zipcode